<template lang="pug">
	.v-field-text.field-text.field-text-edit(:class="computedClass")
		template(v-if="this.field.mask")
			label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
				| {{field.label}}
				span.field-text__star(v-if="field.required") *
			.field-text__cell
				input.field-input(:type="computedType"
					readonly
					:inputmode="field.inputmode"
					:disabled="field.disabled"
					:placeholder="field.placeholder"
					:value="localValue"
					:id="uniqueId"
					v-imask="field.mask"
					@accept="onAccept"
					@complete="onComplete")
				button.field-text__button(v-if="field?.variables?.edit"
					type="button"
					@click="openModal")
					| {{ field?.variables?.edit }}
			span.field-input__error-text {{field.errorText}}

		template(v-else)
			label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
				| {{field.label}}
				span.field-text__star(v-if="field.required") *
			.field-text__cell
				v-svg-icon.field-text__icon(v-if="field.icon" :icon="field.icon")
				input.field-input(
					:type="isModifiedType || computedType"
					readonly
					:inputmode="field.inputmode"
					:disabled="field.disabled"
					:placeholder="field.placeholder"
					v-model="localValue"
					@input="handleInput"
					@keyup="handleKeyup"
					:id="uniqueId")
				button.field-text__button(v-if="field?.variables?.edit"
					type="button"
					@click="openModal")
					| {{ field?.variables?.edit }}
				.field-text__postfix(v-if="field.postfix") {{field.postfix}}
			span.field-input__error-text {{field.errorText}}

</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import controller from "../scripts/controller/controller.js";

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [String, Number],
			default: null
		},

		type: {
			type: String,
			default: null,
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			savedValue: null,
			unmaskedValue: null,
			maskedvalue: null,
			isModifiedType: false,
			fullUnmaskedValueLength: 0,
			uniqueId: uniqueId('field-text_')
		};
	},

	computed: {
		computedType() {
			if (!this.field.type || this.field.type == 'number') {
				return 'text';
			}
			return this.field.type;
		},

		computedClass() {
			return {
				['field-text--' + this.field.size] : this.field.size,
				['field-text--change'] : this.field.change,
				[this.field.className] : this.field.className
			};
		},

		isFieldNumeric() {
			return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				if (this.isFieldNumeric && this.modelValue) {
					this.localValue = this.savedValue = this.modelValue.toString().replace('.', ',');
				} else {
					this.localValue = this.savedValue = this.modelValue;
				}
			}
		}
	},

	methods: {
		openModal() {
			controller.openModal({
				...this.field.modalSetPhone
			})
		},

		changeType(type) {
			this.isModifiedType ? this.isModifiedType = false : this.isModifiedType = type;
		},

		onAccept(e) {
			// console.log(e)
			if (e.detail.unmaskedValue.length !== this.fullUnmaskedValueLength) {
				this.handleInputTel(e);
			}
		},

		onComplete(e) {
			console.log(e)
			this.handleInputTel(e);
		},

		handleKeyup() {
			if (this.isFieldNumeric && this.savedValue) {
				this.localValue = this.savedValue.replace('.', ',');
			}
		},

		handleInputTel(e) {
			this.unmaskedValue = e.detail.unmaskedValue;
			this.maskedvalue = e.detail.value;
			this.fullUnmaskedValueLength = this.unmaskedValue.length;
			this.$emit('update:model-value', this.maskedvalue);
		},

		handleInput() {
			if (this.isFieldNumeric) {
				if (!this.localValue || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localValue)) {
					this.savedValue = this.localValue;
				} else {
					this.localValue = this.savedValue;
				}
				this.$emit('update:model-value', this.localValue ? parseFloat(this.localValue.toString().replace(',', '.')) : this.localValue);
			} else {
				this.$emit('update:model-value', this.localValue);
			}
		},
	}
};
</script>
